import { SB } from '@play-co/replicant';
import createScheduledActions, {
  extractScheduledActionHandlers,
} from '../config/scheduledActions/createScheduledActions';
import { Feature } from '../analytics';
import { deliverChatbotMessage } from '../chatbot/chatbot.util';
import { getChatbotFlexMessage } from '../chatbot/flex/utils';
import { generateReplicantChatbotPayload } from '../chatbot/messageTemplates';
import { getLocale } from '../getters/user';
import { isOnlineOrIdle } from '../getters/presence';

const schema = {
  scheduleGiftOA: SB.object({
    subFeature: SB.string(),
  }),
};

const actions = createScheduledActions(schema)({
  // TODO 2024-02-06: Remove this on next release.
  scheduleGiftOA: async (state, { subFeature }, api) => {
    // Do not send message if the player is online or idle.
    if (isOnlineOrIdle(api)) return;

    const message = getChatbotFlexMessage({
      template: 'giftMessageBatched',
      payload: generateReplicantChatbotPayload({
        feature: Feature.GIFTS._,
        $subFeature: subFeature,
      }),
      data: {
        count: state.gifts.giftBatchCount,
        locale: getLocale(state),
      },
      analyticsUserProperties: {},
    });

    deliverChatbotMessage(
      state,
      api,
      { receiverId: state.id, message, channel: 'oa' }, // Force OA channel
    );
  },
});

export const giftScheduledActions = {
  schema,
  actions: extractScheduledActionHandlers(actions),
};
